<template>
    <div class="mt-5 form-material">
        <h3>Dias por Defecto para Vencimiento de un Booking</h3>
        <div class="row">
            <div class="col-md-1">
                <div class="form-group">
                    <label for="DaysToExpire">Dias por Defecto</label>
                    <input type="number" class="form-control" id="DaysToExpire" v-model="DaysToExpire">
                </div>
            </div>
        </div>
        <div class="col-md-4 d-flex align-items-end">
            <button type="button" class="btn btn-primary btn-sm" @click="updateDaysToExpire" style="width: auto; padding: 0.375rem 0.75rem;">
                Actualizar
            </button>
        </div>
    </div>
  </template>
  
  <script>
  const api = window.api;
  
  export default {
    name: "BookingExpiredDefault",
    data() {
      return {
        DaysToExpire: 15,
      };
    },
    async mounted() {
        const res = await api.get("/api/bookingexpireddefault/");
        if (res) {
            if (res.DaysToExpire) this.DaysToExpire = res.DaysToExpire;
        }
    },
    methods: {
        async updateDaysToExpire() {
            let res = await api.post("/api/bookingexpireddefault/", JSON.stringify({DaysToExpire: this.DaysToExpire}), {'Content-Type': 'application/json' },
             (err) => { 
                this.$root.$refs.index.showNotification(err, 'danger')
             });
            if (res) {
            alert("Días por defecto actualizados");
            }
        },
    },
  };
  </script>
  
